export const REBRAND_BODY_CLASS = 'rebrand';
